import * as S from './style';

interface IProps {
  /** size */
  size?: 'md' | 'xl' | undefined;
}

const PauseIcon = ({ size = 'md' }: IProps) => (
  <S.PauseIcon className="pause-icon" size={size}>
    <span className="line" />
    <span className="line" />
  </S.PauseIcon>
);

export default PauseIcon;
